// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"809":"account","818":"auth","963":"event"}[chunkId] + "." + {"809":"412cfcc9","818":"1f88f0ea","963":"d0a92fbc"}[chunkId] + ".css";
};